import {useState, useEffect} from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import { User } from 'firebase/auth';
import { auth } from './configs/firebaseConfig';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
function Root() {
  const [user, setUser] = useState<User | null>(null);

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((user) => {
      setUser(user);
    });

    return () => unsubscribe();
  }, [user]);

  return (
      <BrowserRouter>
        <App user={user}/>
      </BrowserRouter>
    );
}


root.render(<Root />);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
